<template>
	<div>
		<spinner
			v-if="spinner"
			:message="spinnerMessage"
		/>

		<b-row
			v-else
			class="gy-2"
		>
			<b-col md="3" class="navbar-expand-md">
				<b-row>
					<b-col>
						<h3
							class="page-title"
							:class="( subTitle ) ? 'mb-1' : 'mb-3'"
						>
							<slot name="title">{{ title }}</slot>
						</h3>
						<h5
							v-if="subTitle"
							v-text="subTitle"
							class="user-select-all"
						/>
					</b-col>
					<b-col cols="auto">	
						<b-navbar-toggle target="page_nav_collapse"/>
					</b-col>
				</b-row>

				<b-collapse
					ref="collapse"
					is-nav
					id="page_nav_collapse"
				>
					<slot name="navigation"/>
				</b-collapse>
			</b-col>

			<b-col md="9">
				<slot/>
			</b-col>
		</b-row>
	</div>
</template>

<style lang="scss">
#page_nav_collapse > :first-child {
	width: 100%;
}
</style>

<script>
export default
{
	props:
	{
		spinner:
		{
			type:    Boolean,
			default: false,
		},

		spinnerMessage:
		{
			type:    String,
			default: 'Loading...',
		},

		title:
		{
			type:    String,
			default: null,
		},

		subTitle:
		{
			type:    String,
			default: null,
		},

		transition:
		{
			type:    String,
			default: 'fade',
		},
	},
}
</script>